"use client";

import { SplashScreen } from "@/components";
import ErrorAlert from "@/components/alerts/errorsAlert";
import ExitoAlert from "@/components/alerts/ExitosAlert";
import { useTranslation } from "@/context/LanguageContext";
import React from "react";
import FormLogin from "./Components/Login";
import { useLoginPage } from "./Hooks/useLoginPage";

export const LoginNewClient: React.FC = () => {
    const { t } = useTranslation();
    const {
        email,
        password,
        emailError,
        tab,
        acceptTerms,
        isCheckboxDisabled,
        isSubmitDisabled,
        tipoDocumento,
        numeroDocumento,
        numeroDocumentoError,
        loading,
        tiposIdentificacion,
        loadingTipos,
        rememberMe,
        apiErrorUser,
        showErrorAlert,
        showSuccessAlert,
        successData,
        showSplash,
        onEmailChange,
        onPasswordChange,
        onSubmit,
        onAcceptTermsChange,
        onRememberMeChange,
        onTipoDocumentoChange,
        onNumeroDocumentoChange,
        onRecaptchaVerify,
        onRecaptchaError,
        onRecaptchaExpired,
        onCloseErrorAlert,
        onCloseSuccessAlert,
        onTabChange,
        onSplashFinish,
    } = useLoginPage();

    if (showSplash) {
        return <SplashScreen onFinish={onSplashFinish} duration={3500} />;
    }

    return (
        <>
            <FormLogin
                email={email}
                password={password}
                emailError={emailError}
                tab={tab}
                setTab={onTabChange}
                onEmailChange={onEmailChange}
                onPasswordChange={onPasswordChange}
                onSubmit={onSubmit}
                acceptTerms={acceptTerms}
                onAcceptTermsChange={onAcceptTermsChange}
                rememberMe={rememberMe}
                onRememberMeChange={onRememberMeChange}
                isCheckboxDisabled={isCheckboxDisabled}
                isSubmitDisabled={isSubmitDisabled}
                tipoDocumento={tipoDocumento}
                numeroDocumento={numeroDocumento}
                numeroDocumentoError={numeroDocumentoError}
                onTipoDocumentoChange={onTipoDocumentoChange}
                onNumeroDocumentoChange={onNumeroDocumentoChange}
                onRecaptchaVerify={onRecaptchaVerify}
                onRecaptchaError={onRecaptchaError}
                onRecaptchaExpired={onRecaptchaExpired}
                loading={loading}
                apiError={apiErrorUser}
                tiposIdentificacion={tiposIdentificacion}
                loadingTipos={loadingTipos}
            />

            {showErrorAlert && apiErrorUser && (
                <ErrorAlert
                    title={t("alerts.authenticationError")}
                    message={apiErrorUser}
                    onClose={onCloseErrorAlert}
                />
            )}

            {showSuccessAlert && successData && (
                <ExitoAlert
                    title={successData.title}
                    message={successData.message}
                    onClose={onCloseSuccessAlert}
                />
            )}
        </>
    );
};

export default LoginNewClient;
